import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  AdLabel,
  AdditionalLineDisclaimer,
  PopupDisclaimer,
  PlacementHeadlineWithLink,
  PlacementFinalUrlWithLink,
  PlacementDescription,
  PlacementContentContainer,
  PlacementImage,
} from '../../shared-components';

export const AdPlacementResponsiveSearchPropTypes = {
  propTypes: {
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    classes: PropTypes.shape({
      placementContentContainer: PropTypes.string,
      placementCard: PropTypes.string,
      placementTextContainer: PropTypes.string,
      placementAdsLabel: PropTypes.string,
      placementLongHeadline: PropTypes.string,
      placementFinalUrl: PropTypes.string,
      placementDescriptionContainer: PropTypes.string,
      placementDescription: PropTypes.string,
      placementImage: PropTypes.string,
      placementInlineItems: PropTypes.string,
    }).isRequired,
    decoratorsData: PropTypes.shape({
      disclaimer: PropTypes.shape({
        DisclaimerLayout: PropTypes.string,
      }),
      imageExtension: PropTypes.shape({
        image: PropTypes.shape({}),
        enableCrop: PropTypes.bool,
      }),
    }),
    showAdDisclaimer: PropTypes.bool,
    showImageExtension: PropTypes.bool,
    previewImageAspectRatio: PropTypes.number,
    previewImageHeight: PropTypes.number,
    previewTexts: PropTypes.shape({
      longHeadline: PropTypes.string,
      description: PropTypes.string,
      displayUrl: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
    adExtensionContainerClassName: PropTypes.string,
    children: PropTypes.node,
  },

  defaultProps: {
    showAdDisclaimer: false,
    showImageExtension: false,
    previewImageAspectRatio: 1.78,
    previewImageHeight: 100,
    decoratorsData: {},
    adExtensionContainerClassName: '',
    children: null,
  },
};

export const ResponsiveSearchAdPlacementBase = (props) => {
  const {
    i18n,
    classes,
    showAdDisclaimer,
    showImageExtension,
    previewImageAspectRatio,
    previewImageHeight,
    decoratorsData,
    previewTexts: {
      longHeadline,
      description,
      displayUrl,
      url,
    },
    adExtensionContainerClassName,
    children,
  } = props;

  return (
    <div className={classnames(classes.placementCard, 'ad-placement-card-preview')}>
      <PlacementContentContainer
        placementContentContainerClassName={classes.placementContentContainer}
        isClickDisabled
      >
        <div className={classes.placementInlineContainer}>
          <div className={classes.placementTextContainer}>
            <PlacementHeadlineWithLink
              finalUrl={url}
              headlineText={longHeadline}
              placementHeadlineClassName={classnames(classes.placementLongHeadline, 'long-headline')}
            />
            <div className={classes.placementInlineItems}>
              <PlacementFinalUrlWithLink
                finalUrl={url}
                displayUrl={displayUrl}
                placementFinalUrlClassName={classnames(classes.placementFinalUrl, 'final-url')}
              />
              {
                showAdDisclaimer && decoratorsData.disclaimer && decoratorsData.disclaimer.DisclaimerLayout === 'Popup' &&
                <PopupDisclaimer
                  i18n={i18n}
                  disclaimer={decoratorsData.disclaimer}
                />
              }
            </div>
            <div className={classnames(classes.placementDescriptionContainer, classes.placementInlineItems, 'descriptions')}>
              <AdLabel i18n={i18n} adsLabelClassName={classes.placementAdsLabel} />
              <PlacementDescription
                description={description}
                placementDescriptionClassName={classes.placementDescription}
              />
              {
                showAdDisclaimer && decoratorsData.disclaimer && decoratorsData.disclaimer.DisclaimerLayout === 'AdditionalLine' &&
                <AdditionalLineDisclaimer
                  i18n={i18n}
                  disclaimer={decoratorsData.disclaimer}
                />
              }
            </div>
          </div>
          {
            showImageExtension && decoratorsData.imageExtension && decoratorsData.imageExtension.image &&
            <PlacementImage
              i18n={i18n}
              image={decoratorsData.imageExtension.image}
              enableCrop={decoratorsData.imageExtension.enableCrop}
              previewImageAspectRatio={previewImageAspectRatio}
              previewImageHeight={previewImageHeight}
              placementImageClassName={classes.placementImage}
            />
          }
        </div>
        {children && (
          <div className={classnames(adExtensionContainerClassName, classes.adExtensionContainer)}>
            {children}
          </div>
        )}
      </PlacementContentContainer>
    </div>
  );
};

ResponsiveSearchAdPlacementBase.propTypes = AdPlacementResponsiveSearchPropTypes.propTypes;

ResponsiveSearchAdPlacementBase.defaultProps = AdPlacementResponsiveSearchPropTypes.defaultProps;
